export default function shareToggle() {

    const insertSocialicons = () => {
        const shareDiv = $('.relativeDiv.relativeDiv--share');

        shareDiv.append('<a href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2F6sense.uberflip.com%2F&title=6Sense%20%27s&summary=Check%20out%20what%27s%20happening%20on%206Sense%20Insights%27s%20Hub"><i class="fab fa-linkedin-in"></i></a><a href="https://twitter.com/share?text=Check%20out%20what%27s%20happening%20on%206Sense%20Insights%27s%20Hub&url=https%3A%2F%2F6sense.uberflip.com%2F"><i class="fab fa-twitter"></i></a><a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2F6sense.uberflip.com%2F"><i class="fab fa-facebook-f"></i></a>');
    };

    const toggleShareButton = () => {
        const shareButton = $('.share-toggle');

        shareButton.click(function() {
            shareButton.parent().parent().toggleClass('share-expanded');
        });

        insertSocialicons();
    };

    toggleShareButton();
}


// WEBPACK FOOTER //
// ./scriptPartials/shareToggle.js